import _ from 'lodash';
(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("timeZoneService", ["timeZoneResource", timeZoneService]);
    function timeZoneService(timeZoneResource) {
        var timeZoneServiceFactory = {};
        function detectTimeZone(timeZoneList) {
            var rightNow = new Date();
            var timeZoneOffset = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0).getTimezoneOffset() * -1;
            var isNegative = timeZoneOffset < 0;
            var minutes = Math.abs(timeZoneOffset % 60);
            var hour = Math.abs((timeZoneOffset - minutes) / 60);
            var formattedTime = (isNegative ? "-" : "") + pad(hour.toString(), 2) + ":" + pad(minutes.toString(), 2) + ":00";
            //Get standard name of time zone
            var timeZoneName = "";
            if (rightNow.toString().indexOf("(") >= 0) {
                timeZoneName = /\((.*)\)/.exec(rightNow.toString())[1];
            }
            var detectedTimeZone = _.find(timeZoneList, { DaylightName: timeZoneName });
            if (!detectedTimeZone) {
                detectedTimeZone = _.find(timeZoneList, { StandardName: timeZoneName });
                if (!detectedTimeZone)
                    detectedTimeZone = _.find(timeZoneList, { BaseUtcOffset: formattedTime });
            }
            return detectedTimeZone;
        }
        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        function getListOfTimeZones(callback) {
            timeZoneResource.getListOfTimeZones(function (data) {
                callback(data);
            });
        }
        timeZoneServiceFactory.detectTimeZone = detectTimeZone;
        timeZoneServiceFactory.getListOfTimeZones = getListOfTimeZones;
        return timeZoneServiceFactory;
    }
}());
